import React from 'react';
import { 
  Users, 
  Target,
  Calendar,
  Rocket,
  Server,
  Zap
} from 'lucide-react';

const Nov24Report = () => {
  return (
    <div className="status-report">
      <div className="report-header">
        <h1 className="report-title">
          <Calendar className="w-8 h-8 text-blue-600" />
          Executive Update - November 24th, 2025
        </h1>
        <div className="report-meta">
          <span className="meta-item">
            <Calendar className="w-4 h-4" />
            November 24, 2025
          </span>
          <span className="meta-item">
            <Target className="w-4 h-4" />
            Executive Summary
          </span>
        </div>
      </div>

      <div className="report-grid">
        {/* Prequal */}
        <div className="report-section">
          <h2 className="section-title">
            <Rocket className="w-6 h-6 text-green-600" />
            Prequal
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Deployment Status</h3>
                <span className="status-badge completed">DEPLOYED</span>
              </div>
              <ul className="achievement-list">
                <li><strong>Deployment Date:</strong> November 14, 2025</li>
                <li>Successfully deployed to production</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Initial Accuracy Report</h3>
                <span className="status-badge completed">COMPLETED</span>
              </div>
              <div style={{ marginTop: '15px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                  <thead>
                    <tr style={{ backgroundColor: 'rgba(96, 165, 250, 0.1)' }}>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid rgba(148, 163, 184, 0.3)' }}>Doc Type</th>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid rgba(148, 163, 184, 0.3)' }}>No. of Docs</th>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid rgba(148, 163, 184, 0.3)' }}>Accuracy</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>Surety Letter</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>5</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>Work In Progress</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>5</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>CPA Financials (Combined)</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>8</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>97.83%</td>
                    </tr>
                    <tr style={{ paddingLeft: '20px' }}>
                      <td style={{ padding: '8px 8px 8px 30px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', fontSize: '0.9em', color: '#94a3b8' }}>Balance Sheet</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>7</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>98.41%</td>
                    </tr>
                    <tr style={{ paddingLeft: '20px' }}>
                      <td style={{ padding: '8px 8px 8px 30px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', fontSize: '0.9em', color: '#94a3b8' }}>Income Statement</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>8</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>96.65%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>Line of Credit</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>5</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>EMR Worksheet</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>5</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>BLS Incident Rates</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>5</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>D&B Credit Report</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>7</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#f59e0b', fontWeight: '600' }}>71.43%</td>
                    </tr>
                    <tr style={{ backgroundColor: 'rgba(96, 165, 250, 0.1)', fontWeight: '600' }}>
                      <td style={{ padding: '10px', borderBottom: 'none' }}><strong>Avg. Accuracy</strong></td>
                      <td style={{ padding: '10px', borderBottom: 'none' }}><strong>40</strong></td>
                      <td style={{ padding: '10px', borderBottom: 'none', color: '#22c55e' }}><strong>94.57%</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Updated Accuracy Report</h3>
                <span className="status-badge completed">IMPROVED</span>
              </div>
              <div style={{ marginTop: '15px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                  <thead>
                    <tr style={{ backgroundColor: 'rgba(96, 165, 250, 0.1)' }}>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid rgba(148, 163, 184, 0.3)' }}>Doc Type</th>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid rgba(148, 163, 184, 0.3)' }}>No. of Docs</th>
                      <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid rgba(148, 163, 184, 0.3)' }}>Accuracy</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>Surety Letter</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>11</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>Work In Progress</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>10</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>96.67%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>CPA Financials (Combined)</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>12</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>98.06%</td>
                    </tr>
                    <tr style={{ paddingLeft: '20px' }}>
                      <td style={{ padding: '8px 8px 8px 30px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', fontSize: '0.9em', color: '#94a3b8' }}>Balance Sheet</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>11</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>96.84%</td>
                    </tr>
                    <tr style={{ paddingLeft: '20px' }}>
                      <td style={{ padding: '8px 8px 8px 30px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', fontSize: '0.9em', color: '#94a3b8' }}>Income Statement</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>12</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>Line of Credit</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>11</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>EMR Worksheet</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>8</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>BLS Incident Rates</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>9</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#22c55e', fontWeight: '600' }}>100%</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>D&B Credit Report</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)' }}>10</td>
                      <td style={{ padding: '8px', borderBottom: '1px solid rgba(148, 163, 184, 0.2)', color: '#f59e0b', fontWeight: '600' }}>80%</td>
                    </tr>
                    <tr style={{ backgroundColor: 'rgba(96, 165, 250, 0.1)', fontWeight: '600' }}>
                      <td style={{ padding: '10px', borderBottom: 'none' }}><strong>Avg. Accuracy</strong></td>
                      <td style={{ padding: '10px', borderBottom: 'none' }}><strong>71</strong></td>
                      <td style={{ padding: '10px', borderBottom: 'none', color: '#22c55e' }}><strong>96.39%</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Kinetic */}
        <div className="report-section">
          <h2 className="section-title">
            <Zap className="w-6 h-6 text-yellow-600" />
            Kinetic
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Deployment Status</h3>
                <span className="status-badge completed">DEPLOYED</span>
              </div>
              <ul className="achievement-list">
                <li>Single project upload feature successfully deployed</li>
                <li>Production-ready functionality</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Current Challenges</h3>
                <span className="status-badge in-progress">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Variance of documents causing processing issues</li>
                <li>Active improvements in progress</li>
                <li>Working on enhanced document handling</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Next Steps</h3>
                <span className="status-badge scheduled">SCHEDULED</span>
              </div>
              <ul className="achievement-list">
                <li>Release planned for this week</li>
                <li>Addressing document variance challenges</li>
                <li>Enhanced processing capabilities</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Baldwin */}
        <div className="report-section">
          <h2 className="section-title">
            <Users className="w-6 h-6 text-indigo-600" />
            Baldwin
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Field Launches</h3>
                <span className="status-badge completed">DEPLOYED</span>
              </div>
              <ul className="achievement-list">
                <li><strong>5 Standard Fields</strong> - Successfully launched</li>
                <li><strong>4 Fields</strong> - In queue for this week's deployment</li>
                <li>Continued expansion of field coverage</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Accuracy Improvements</h3>
                <span className="status-badge completed">IMPROVED</span>
              </div>
              <ul className="achievement-list">
                <li>Continued improvements for quotes and binders</li>
                <li>New comparison field: <strong>"Attached/Non-attached"</strong></li>
                <li>Enhanced field extraction accuracy</li>
                <li>Better handling of document variations</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Baldwin Infrastructure */}
        <div className="report-section">
          <h2 className="section-title">
            <Server className="w-6 h-6 text-purple-600" />
            Baldwin - Infrastructure Optimization
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Cost Optimization</h3>
                <span className="status-badge completed">TESTING</span>
              </div>
              <ul className="achievement-list">
                <li>Internal testing completed for external hosting options</li>
                <li><strong>RunPod</strong> identified as best contender</li>
                <li>Potential <strong>50% GPU cost savings</strong></li>
                <li>Significant infrastructure cost reduction opportunity</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Architecture Improvements</h3>
                <span className="status-badge in-progress">IN PROGRESS</span>
              </div>
              <ul className="achievement-list">
                <li>Containerization work in progress</li>
                <li>Creating microservices for modules</li>
                <li>On-demand compute implementation</li>
                <li>Scalable and cost-effective architecture design</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Timeline</h3>
                <span className="status-badge scheduled">SCHEDULED</span>
              </div>
              <ul className="achievement-list">
                <li><strong>Internal Release:</strong> Scheduled for end of next week</li>
                <li>Containerization and microservices completion</li>
                <li>On-demand compute infrastructure ready</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Summary & Next Steps */}
        <div className="report-section">
          <h2 className="section-title">
            <Target className="w-6 h-6 text-teal-600" />
            Summary & Next Steps
          </h2>
          
          <div className="achievement-cards">
            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Key Achievements</h3>
                <span className="status-badge completed">✓</span>
              </div>
              <ul className="achievement-list">
                <li><strong>Prequal:</strong> Deployed Nov 14th with 96.39% average accuracy</li>
                <li><strong>Kinetic:</strong> Single project upload deployed</li>
                <li><strong>Baldwin:</strong> 5 standard fields launched, 4 in queue</li>
                <li><strong>Infrastructure:</strong> RunPod testing completed, 50% cost savings potential</li>
              </ul>
            </div>

            <div className="achievement-card">
              <div className="achievement-header">
                <h3>Immediate Priorities</h3>
                <span className="status-badge in-progress">ONGOING</span>
              </div>
              <ul className="achievement-list">
                <li><strong>Kinetic:</strong> Release improvements this week for document variance</li>
                <li><strong>Baldwin:</strong> Deploy 4 additional fields this week</li>
                <li><strong>Baldwin:</strong> Complete containerization and microservices by end of next week</li>
                <li>Continue accuracy improvements across all products</li>
              </ul>
            </div>
          </div>
        </div>

      </div>

      <div className="report-footer">
        <p><strong>Prepared by:</strong> Naqi & Claude</p>
        <p><strong>Report Date:</strong> November 24, 2025</p>
      </div>
    </div>
  );
};

export default Nov24Report;

